// removed by extract-text-webpack-plugin
module.exports = {"full":"full-3he47"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/grid/styles.scss
 ** module id = 21
 ** module chunks = 0
 **/